import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MarqueService {

  constructor(private httpClient: HttpClient) {}

  getData() {
    return this.httpClient.get(environment.Localurl + "marque");
  }

  insertData(data) {
    return this.httpClient.post(environment.Localurl + "marque", data);
  }

  deleteData(id) {
    return this.httpClient.delete(environment.Localurl + "marque/" + id);
  }

  getOneData(id) {
    return this.httpClient.get(environment.Localurl + "marque/" + id);
  }

  updateData(id, data) {
    return this.httpClient.put(environment.Localurl + "marque/" + id, data);
  }
}
